// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"CoachesPage_toolbar__2M784","add":"CoachesPage_add__1jFAL","table":"CoachesPage_table__1F5IZ"};